<template>
  <v-container fluid class="nosepara_topbot">
    <v-flex md12 sd12>
      <v-layout v-if="formload" row wrap>
        <v-flex text-md-center>
          <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
      <v-flex v-else>
        <v-flex sm12 md12>
          <v-layout row wrap>
            <v-flex md12 mt-3>
              <v-layout row wrap md12>
                <v-flex md2 class="hidden-sm-and-down">
                  <v-card-title mb-1 class="title tw-txt-color-primary text-xs-right">{{ `workers.title_status` | t }}</v-card-title>
                </v-flex>
                <v-flex md8>
                  <v-card-title class="nosepara_topbot">
                    <consumer-workers class="ml-3 mt-1" this.status_add="false;" :counter="getConsumer(w_type).counter" :counter_limit="getConsumer(w_type).counter_limit" :w_type="w_type" />
                  </v-card-title>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-flex>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import ConsumerWorkers from '@/components/ConsumerWorkers'

export default {
  props: ['user', 'w_type'],
  components: {
    ConsumerWorkers
  },
  computed: {
    ...mapGetters(['getTokenHeader', 'getServer', 'getConsumer', 'getUserId'])
  },
  methods: {
    ...mapActions(['setMyConsumers', 'rmKey'])
  },
  data() {
    return {
      formload: true,
      limit_add: true
    }
  },
  created() {
    const userid = this.user ? parseInt(this.user, 0) : this.getUserId
    this.$http
      .get(`${this.getServer}/users/${userid}/consumers`, this.getTokenHeader)
      .then(data => {
        if (data.data) {
          this.setMyConsumers(data.data)
          this.formload = false
        }
      })
      .catch(() => {
        this.rmKey()
      })
  }
}
</script>
<style scoped>
.nosepara_topbot {
  /*padding: 6px 20px !important;*/
  position: static !important;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.tw-txt-color-primary {
  /*color: #00ff37 !important;*/
  color: #515151 !important;
}
</style>
